<template>
    <div class="page">
      <v-container fluid>
        <v-form ref="form">
          <v-row class="d-flex justify-center mt-3">
            <v-col cols="3">
              <v-text-field
                label="Nome do Termo"
                v-model="form.filters.termo"
                outlined
                maxlength="40"
                dense
              ></v-text-field>
            </v-col>
            <sigfoco-select-ativo
                :cols="3"
                v-model="form.filters.situacao"
                labelType="Situação"
          ></sigfoco-select-ativo>
          </v-row>
          <div class="text-center">
            <v-col cols="12">
              <sigfoco-tooltip
                :text="'Buscar'"
                :icon="'mdi-magnify'"
                @click="buscarTermos()"
              ></sigfoco-tooltip>
              <sigfoco-tooltip
                :text="'Limpar'"
                :icon="'mdi-eraser'"
                @click="resetForm()"
              ></sigfoco-tooltip>
              <sigfoco-tooltip
                :text="'Incluir'"
                :icon="'mdi-plus'"
                @click="openDialogManterTermo()"
              ></sigfoco-tooltip>
            </v-col>
          </div>
        </v-form>
        <v-data-table
          class="mt-5"
          :headers="headers"
          :items="form.lists.listTermos"
          :items-per-page="10"
          :footer-props="$footerProps"
        >
            <template v-slot:[`item.nome`]="{ item }">
                {{ item.nome }}
            </template>
            <template v-slot:[`item.tipo`]="{ item }">
                {{ item.tipo.descricao }}
            </template>
            <template v-slot:[`item.situacao`]="{ item }">
                <sigfoco-label-ativo-inativo :ativo="item.situacao"></sigfoco-label-ativo-inativo>
            </template>
            <template v-slot:[`item.acoes`]="{ item }">
                <sigfoco-tooltip
                    :text="'Visualizar'"
                    :icon="'mdi-eye-outline'"
                    :small="true"
                    @click="openDialogVisualizarTermo(item)"
                ></sigfoco-tooltip>
                <sigfoco-tooltip
                    :text="'Editar'"
                    :icon="'mdi-pencil'"
                    :small="true"
                    :disabled="!item.situacao"
                    @click="openDialogManterTermo(item)"
                ></sigfoco-tooltip>
                <sigfoco-tooltip
                    :text="`${item.situacao ? 'Inativar' : 'Ativar'}`"
                    :icon="`${item.situacao ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off'}`"
                    :color="`${item.situacao ? 'var(--primary-button-color)' : 'silver'}`"
                    :small="true"
                    :disabled="!item.situacao"
                    @click="inativarAtivarTermo(item)"
                ></sigfoco-tooltip>
            </template>
        </v-data-table>
      </v-container>
      <CadastrarEditarTermoDialog
        :visible="dialogManterTermo.visible"
        :content="dialogManterTermo.content"
        :edit="dialogManterTermo.edit"
        @onClose="dialogManterTermo.close()"
        @onSave="buscarTermos()"
      ></CadastrarEditarTermoDialog>
      <VisualizarTermoDialog
        :visible="dialogVisualizarTermo.visible"
        :content="dialogVisualizarTermo.content"
        @onClose="dialogVisualizarTermo.close()"
      ></VisualizarTermoDialog>
    </div>
  </template>
  
<script>
    import { Dialog } from "~/commons/classes/dialog";
    import { Termo } from "~/commons/classes/termo";
    import CadastrarEditarTermoDialog from "./dialogs/CadastrarEditarTermoDialog.vue";
    import VisualizarTermoDialog from "./dialogs/VisualizarTermoDIalog.vue";
    import TermoService from '~/services/manter-termo.service';
  
    export default {
        name: "ManterTermoView",
        mixins: [TermoService],
        components: {
        CadastrarEditarTermoDialog,
        VisualizarTermoDialog,
        },
        data: () => ({
        dialogManterTermo: Dialog.Build(),
        dialogVisualizarTermo: Dialog.Build(),
        form: {
            filters: {
            termo: null,
            situacao: null,
            },
            lists: {
            listTermos: []
            }
        },
        headers: [
            { text: "Nome do Termo", align: "center", value: "nome" },
            { text: "Tipo", align: "center", value: "tipo" },
            { text: "Situação", align: "center", value: "situacao" },
            { text: "Ações", align: "center", value: "acoes", sortable: false },
        ]
        }),
        methods: {
        openDialogManterTermo(termo) {
            termo
            ? this.$visualizarTermo(termo).then(({ data }) => {
                this.dialogManterTermo.open(new Termo(data.termo).format(), true);
                })
            : this.dialogManterTermo.open(Termo.Build());
        },
        openDialogVisualizarTermo(termo) {
            this.$visualizarTermo(termo).then(
            ({ data }) => (this.dialogVisualizarTermo.open(data.termo))
            );
        },
        buscarTermos() {
            this.$buscarTermos({ params: this.form.filters }).then(
            ({ data }) => (this.form.lists.listTermos = data.lista)
            );
        },
        inativarAtivarTermo(termo) {
            this.$swal({
            text: `Deseja confirmar a ${
                termo.situacao ? "inativação" : "ativação"
            } do Termo?`,
            type: "warning",
            showCancelButton: true,
            confirmButtonText: `Confirmar`,
            cancelButtonText: `Cancelar`,
            }).then(() => {
            this.$inativarAtivarTermo(
                { id: termo.id},
                termo.id
            ).then(({ data }) => {
                this.$notifySuccess(data.mensagem);
                this.buscarTermos();
              });
            });
        },
        resetForm() {
            this.$resetForm();
            this.form.lists.listTermos = [];
            this.form.filters.ativo = null;
        },
        },
    };
</script>
<style scoped>
  .grupos {
    padding: 1em !important;
    text-align: center;
    font-weight: 500;
  }
  .grupo {
    padding-right: 0.5em;
  }
</style>
  